<template>
    <div class="tabcontent">
        <v-container :fluid="true" v-resize="onResize" ref="bddsfactcontainer">
            <v-row align="center">
                <v-col cols="12" md="2" sm="3">
                    <v-select
                            v-model="yearbdds"
                            :items="yearfilter"
                            label="Год"
                            @input="changeYearHandle"
                    ></v-select>
                </v-col>
                <!--
                <v-col cols="12" md="2" sm="3">
                  <v-select
                      multiple
                      v-model="monthbdds"
                      :items="monthsFilter"
                      label="Месяц"
                      @input="changeYearHandle"
                  ></v-select>
                </v-col>
                -->
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdOrg"
                                :items="orglist"
                                label="Организация"
                                @input="changeOrg"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
                <v-col cols="12" md="3" sm="6">
                    <v-skeleton-loader
                            :loading="loading"
                            type="list-item"
                            class="mx-auto"
                    >
                        <v-select
                                v-model="IdHouse"
                                :items="houselist"
                                label="Объект"
                                @input="changeHouse"
                        ></v-select>
                    </v-skeleton-loader>
                </v-col>
                <v-col class="rightExPd" cols="12" md="2" sm="3">
                    <v-btn color="primary" @click="updateClick()">
                        <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="excelFactList" dark>
                      <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-skeleton-loader
                :loading="loading"
                type="table-tbody"
                class="mx-auto"
        >
        <v-card>
            <v-simple-table>
                <template>
                    <thead>
                    <tr>
                        <th class="stick sticky-header" style="min-width: 280px;">Статья оборота</th>
                        <th class="sticky-header" v-for="month in months" :key="month" style="min-width: 80px;">
                            {{ month }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="stick">Сальдо на начало</td>
                        <td v-for="item in bddsBegOst" :key="item.ID" class="text-right">{{item.Val | toCurrency}}</td>
                    </tr>
                    <tr>
                        <td>
                          <v-btn icon color="default darken-1" @click="clickShow('in')" v-show="bddsIn.length>0">
                            <v-icon class="mdi-18px">{{iconExpand('in')}}</v-icon>
                          </v-btn>
                          <span class="font-weight-black">Поступления</span>
                        </td>
                        <td v-for="SummIn in In" :key="SummIn.ID" class="text-right">
                          {{ SummIn.Val | toCurrency }}
                        </td>
                    </tr>
                    <template v-for="(group, indexgr) in bddsIn">
                        <tr :key="'g'+group.ID" v-if="group.ID > 0" v-show="ShowId('in')">
                            <td class="stick">
                                <v-btn icon color="default darken-1" @click="clickShow(group.ID)" v-show="group.sub.length>0">
                                  <v-icon class="mdi-18px">{{iconExpand(group.ID)}}</v-icon>
                                </v-btn>
                                <span class="font-weight-bold">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }} {{ group.Name }}</span>
                            </td>
                            <td v-for="SummGroup in group.Sums" :key="SummGroup.ID" class="text-right">
                              {{ SummGroup.Val | toCurrency }}
                            </td>
                        </tr>
                        <template v-for="(item, indexs) in group.sub">
                            <tr :key="'s'+item.ID" v-show="ShowId(group.ID) && ShowId('in')">
                                <td class="stick">
                                    <v-btn icon color="default darken-1" @click="clickShow(item.ID)" v-show="item.sub.length>0">
                                      <v-icon class="mdi-18px">{{iconExpand(item.ID)}}</v-icon>
                                    </v-btn>
                                    <span class="pl-2 font-weight-medium">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }} {{ item.Name }}</span>
                                </td>
                                <td v-for="Summ in item.Sums" :key="Summ.ID" class="text-right">
                                    {{ Summ.Val | toCurrency }}
                                </td>
                            </tr>
                            <tr v-for="(subitem, indexsub) in item.sub" :key="'s'+item.ID+'s'+subitem.ID" v-show="ShowId(item.ID) && ShowId(group.ID) && ShowId('in')">
                                <td class="stick" >
                                    <div class="pl-14">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }}.{{ subitem.Numb>0 ? subitem.Numb : indexsub + 1 }} {{ subitem.Name }}</div>
                                </td>
                                <td v-for="Summsub in subitem.Sums" :key="Summsub.ID" class="text-right">
                                    {{ Summsub.Val | toCurrency }}
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tr>
                        <td>
                          <v-btn icon color="default darken-1" @click="clickShow('out')" v-show="bddsOut.length>0">
                            <v-icon class="mdi-18px">{{iconExpand('out')}}</v-icon>
                          </v-btn>
                          <span class="font-weight-black">Расходы</span>
                        </td>
                        <td v-for="SummOut in Out" :key="SummOut.ID" class="text-right">
                          {{ SummOut.Val | toCurrency }}
                        </td>
                    </tr>
                    <template v-for="(group, indexgr) in bddsOut">
                        <tr :key="'g'+group.ID" v-if="group.ID > 0" v-show="ShowId('out')">
                            <td class="stick">
                                <v-btn icon color="default darken-1" @click="clickShow(group.ID)" v-show="group.sub.length>0">
                                  <v-icon class="mdi-18px">{{iconExpand(group.ID)}}</v-icon>
                                </v-btn>
                                <span class="font-weight-bold">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }} {{ group.Name }}</span>
                            </td>
                            <td v-for="SummGroup in group.Sums" :key="SummGroup.ID" class="text-right">
                              {{ SummGroup.Val | toCurrency }}
                            </td>
                        </tr>
                        <template v-for="(item, indexs) in group.sub">
                            <tr :key="'s'+item.ID" v-show="ShowId(group.ID) && ShowId('out')">
                                <td class="stick">
                                    <v-btn icon color="default darken-1" @click="clickShow(item.ID)" v-show="item.sub.length>0">
                                      <v-icon class="mdi-18px">{{iconExpand(item.ID)}}</v-icon>
                                    </v-btn>
                                    <span class="pl-2 font-weight-medium">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }} {{ item.Name }}</span>
                                </td>
                                <td v-for="Summ in item.Sums" :key="Summ.ID" class="text-right">
                                    {{ Summ.Val | toCurrency }}
                                </td>
                            </tr>
                            <tr v-for="(subitem, indexsub) in item.sub" :key="'s'+item.ID+'s'+subitem.ID" v-show="ShowId(item.ID) && ShowId(group.ID) && ShowId('out')">
                                <td class="stick">
                                    <div class="pl-14">{{ group.Numb>0 ? group.Numb : parseInt(indexgr) + 1 }}.{{ item.Numb>0 ? item.Numb : indexs + 1 }}.{{ subitem.Numb>0 ? subitem.Numb : indexsub + 1 }} {{ subitem.Name }}</div>
                                </td>
                                <td v-for="Summsub in subitem.Sums" :key="Summsub.ID" class="text-right">
                                    {{ Summsub.Val | toCurrency }}
                                </td>
                            </tr>
                        </template>
                    </template>
                    <tr>
                        <td class="stick">Сальдо на конец</td>
                        <td v-for="item in bddsEndOst" :key="item.ID" :class="'text-right ' + endColor(item.Val)">{{item.Val | toCurrency}}</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
        </v-skeleton-loader>
    </div>
</template>

<script>

    import { bus } from '../../plugins/bus.js';

    export default {
        name: "BddsFact",
        mounted() {

            this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, month: this.monthbddsGet, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                this.$store.dispatch('GET_BDDSFACTLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse}).then(() => {
                    this.loading = false;
                });
            });

            bus.$on('refreshTabBddsFact', this.refreshHandler);
        },
        beforeMount () {
            this.loadFilters();
        },
        data() {
            return {
                loading: true,
                yearbdds: new Date().getFullYear(),
                monthbdds: [],
                monthbddsGet: '',
                monthsFilter: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                IdOrg: localStorage.getItem('idtsg'),
                IdHouse: '',
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                heightTable: (window.innerHeight - 200),
                expand: [{expand: false, ID: 'in'}],
                expandOut: [{expand: false, ID: 'out'}],
            }
        },
        methods: {
            loadFilters: function() {
                let year = localStorage.getItem('VUE_TABS_BDDSFACT_YEAR');
                if (year) {
                    this.IdOrg = JSON.parse(year);
                }
                /*let month = localStorage.getItem('VUE_TABS_BDDSFACT_MONTH');
                if (month) {
                  this.monthbdds = JSON.parse(month);
                  if(this.monthbdds.length>0){
                    this.months = [];
                    for (let hs of this.monthsFilter) {
                      if (this.monthbdds.indexOf( hs ) != -1) {
                        this.months.push(hs);
                      }
                    }
                    this.monthbddsGet = '';
                    for (let bdds of this.monthbdds) {
                      this.monthbddsGet = this.monthbddsGet+';'+bdds;
                    }
                  }
                }else{
                  this.monthbddsGet = '';
                }*/
                let org = localStorage.getItem('VUE_TABS_BDDSFACT_ORG');
                if (org) {
                    this.IdOrg = JSON.parse(org);
                }
                let house = localStorage.getItem('VUE_TABS_BDDSFACT_HOUSE');
                if (house) {
                    this.IdHouse = JSON.parse(house);
                }
            },
            saveFilters: function() {
                localStorage.setItem('VUE_TABS_BDDSFACT_YEAR', JSON.stringify(this.yearbdds));
                localStorage.setItem('VUE_TABS_BDDSFACT_MONTH', JSON.stringify(this.monthbdds));
                localStorage.setItem('VUE_TABS_BDDSFACT_ORG', JSON.stringify(this.IdOrg));
                localStorage.setItem('VUE_TABS_BDDSFACT_HOUSE', JSON.stringify(this.IdHouse));
                let month = localStorage.getItem('VUE_TABS_BDDSFACT_MONTH');
                if (month) {
                  this.monthbdds = JSON.parse(month);
                  if(this.monthbdds.length>0){
                    this.months = [];
                    for (let hs of this.monthsFilter) {
                      if (this.monthbdds.indexOf( hs ) != -1) {
                        this.months.push(hs);
                      }
                    }
                    this.monthbddsGet = '';
                    for (let bdds of this.monthbdds) {
                      this.monthbddsGet = this.monthbddsGet+';'+bdds;
                    }
                  }else{
                    this.months = this.monthsFilter;
                    this.monthbddsGet = '';
                  }
                }else{
                  this.monthbddsGet = '';
                }
            },
            changeYearHandle() {
                this.saveFilters();
                this.updateClick();
            },
            changeOrg() {
                this.$store.dispatch('GET_ORGFILTERS', {IdOrg: this.IdOrg, IdHouse: this.IdHouse > 0 ? this.IdHouse : -1}).then(() => {
                    this.updateClick();
                });
                this.saveFilters();
            },
            changeHouse() {
                if (this.IdHouse > 0) {
                    if (this.$store.getters.ORGFILTERS) {
                        this.$store.getters.ORGFILTERS.houselist.forEach((item) => {
                            if (item.ID == this.IdHouse) {
                                this.IdOrg = item.IdTsj;
                                return false;
                            }
                        });
                    }
                }
                this.saveFilters();
                this.updateClick();
            },
            updateClick() {
                //this.expand = [{expand: false, ID: 'in'}];
                //this.expandOut = [{expand: false, ID: 'out'}];
                this.$store.dispatch('GET_BDDSFACTLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse});
            },
            switchTarifClick() {
                this.updateClick();
            },
            endColor(Val) {
                return Val > 0 ? "black--text" : "red--text";
            },
            refreshHandler() {
                this.updateClick();
            },
            onResize() {
                //this.heightTable = (window.innerHeight - this.$refs.bddsfactcontainer.clientHeight - 125);
            },
            excelFactList(){
              this.$store.dispatch('EXCEL_BDDSFACTLIST', {year: this.yearbdds, month: this.monthbddsGet, IdOrg: this.IdOrg, IdHouse: this.IdHouse}).then(response => {
                window.open(response.data);
              });
            },
            ShowId(id){
              let ret = false;
              this.expand.forEach((item) => {
                if(item.ID == id)
                  ret = item.expand;
              });
              this.expandOut.forEach((item) => {
                if(item.ID == id)
                  ret = item.expand;
              });
              return ret;
            },
            clickShow(id){
              this.expand.forEach((item) => {
                if(item.ID == id){
                  if(item.expand)
                    item.expand = false;
                  else
                    item.expand = true;
                }
              });
              this.expandOut.forEach((item) => {
                if(item.ID == id){
                  if(item.expand)
                    item.expand = false;
                  else
                    item.expand = true;
                }
              });
            },
            iconExpand(id){
              let ret = 'mdi-plus-box-outline';
              this.expand.forEach((item) => {
                if(item.ID == id && item.expand)
                  ret = 'mdi-minus-box-outline';
              });
              this.expandOut.forEach((item) => {
                if(item.ID == id && item.expand)
                  ret = 'mdi-minus-box-outline';
              });
              return ret;
            }
        },
        computed: {
            yearfilter() {
                let nowYear = new Date().getFullYear() + 1;
                let years = [];
                for (let i = 0; i < 5; i++) {
                    years.push(nowYear - i);
                }
                return years;
            },
            bddsIn() {
                if(this.$store.getters.BDDSFACTLIST){
                  this.$store.getters.BDDSFACTLIST.datain.forEach((item) => {
                    let exp = true;
                    for (let Out of this.expand){
                      if(Out.ID == item.ID)
                        exp = false;
                    }
                    if(exp)
                      this.expand.push({expand: false, ID: item.ID});
                    if(item.sub.length>0){
                      item.sub.forEach((sub) => {
                        let exp = true;
                        for (let Out of this.expand){
                          if(Out.ID == sub.ID)
                            exp = false;
                        }
                        if(exp)
                          this.expand.push({expand: false, ID: sub.ID});
                      });
                    }
                  });
                }
                return this.$store.getters.BDDSFACTLIST ? this.$store.getters.BDDSFACTLIST.datain : [];
            },
            bddsOut() {
                if(this.$store.getters.BDDSFACTLIST){
                  this.$store.getters.BDDSFACTLIST.dataout.forEach((item) => {
                    let exp = true;
                    for (let Out of this.expandOut){
                      if(Out.ID == item.ID)
                        exp = false;
                    }
                    if(exp)
                      this.expandOut.push({expand: false, ID: item.ID});
                    if(item.sub.length>0){
                      item.sub.forEach((sub) => {
                        let exp = true;
                        for (let Out of this.expandOut){
                          if(Out.ID == sub.ID)
                            exp = false;
                        }
                        if(exp)
                          this.expandOut.push({expand: false, ID: sub.ID});
                      });
                    }
                  });
                }
                return this.$store.getters.BDDSFACTLIST ? this.$store.getters.BDDSFACTLIST.dataout : [];
            },
            In() {
              return this.$store.getters.BDDSFACTLIST ? this.$store.getters.BDDSFACTLIST.arIn : [];
            },
            Out() {
              return this.$store.getters.BDDSFACTLIST ? this.$store.getters.BDDSFACTLIST.arOut : [];
            },
            bddsBegOst() {
                return this.$store.getters.BDDSFACTLIST ? this.$store.getters.BDDSFACTLIST.databegost : [];
            },
            bddsEndOst() {
                return this.$store.getters.BDDSFACTLIST ? this.$store.getters.BDDSFACTLIST.dataendost : [];
            },
            houselist() {
                let ret = [{text: 'Все', value: -1}];
                if (this.$store.getters.ORGFILTERS) {
                    this.$store.getters.ORGFILTERS.houselist.forEach((item) => {
                        if (this.IdOrg == '' || (this.IdOrg > 0 && item.IdTsj == this.IdOrg)) {
                            ret.push({text: item.Name, value: item.ID});
                        }
                    });
                }
                return ret;
            },
            orglist() {
                let ret = [];
                if (this.$store.getters.ORGFILTERS) {
                  if(localStorage.getItem('idtsg')>0){
                    this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                      if(item.ID == localStorage.getItem('idtsg'))
                        ret.push({text: item.Name, value: item.ID});
                    });
                  }else{
                    this.$store.getters.ORGFILTERS.orglist.forEach((item) => {
                      ret.push({text: item.Name, value: item.ID});
                    });
                  }
                }
                return ret;
            }
        },
        filters: {
            toCurrency: function (value) {
                if (value === undefined) value = 0;
                let formatter = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});
                return formatter.format(value/1);
            }
        },
    }
</script>

<style scoped>
    .tabcontent {
        padding-top: 35px;
    }
    .rightExPd button{
      margin: 0px 5px;
    }
    .v-data-table /deep/ .sticky-header {
      position: sticky;
      top: 126px;
      z-index: 1;
      background: #fff;
    }
    .v-data-table /deep/ .v-data-table__wrapper {
      overflow: unset;
    }
</style>